import {TrainingPlanProvider as TrainingPlanSelectorWithInitialDataPresenterTrainingPlanProvider} from './ui/TrainingPlanSelectorWithInitialDataPresenter';
import {TrainingPlanProvider as TrainingPlanSearchModalPresenterTrainingPlanProvider} from './ui/TrainingPlanSearchModal/TrainingPlanSearchModalPresenter';
import {DefaultTrainingPlanProvider} from './network/DefaultTrainingPlanProvider';
import {lazy} from '../support/lazy';
import {TrainingPlan} from './models/TrainingPlan';

export interface Component {
    trainingPlanProvider:
        | TrainingPlanSelectorWithInitialDataPresenterTrainingPlanProvider
        | TrainingPlanSearchModalPresenterTrainingPlanProvider;
}

export class DefaultComponent implements Component {
    constructor(private trainingPlans: TrainingPlan[]) {}

    @lazy()
    public get trainingPlanProvider():
        | TrainingPlanSelectorWithInitialDataPresenterTrainingPlanProvider
        | TrainingPlanSearchModalPresenterTrainingPlanProvider {
        return new DefaultTrainingPlanProvider(this.trainingPlans);
    }
}

let instance: Component;

export function setComponent(c: Component): void {
    instance = c;
}

export function component(): Component {
    if (instance === undefined) {
        throw new Error('Component is not set');
    }

    return instance;
}
